export default theme => ({
  paper: {
    margin: '50px',
    padding: '25px',
  },
  centred: {
    textAlign: 'center',
  },
  tableRowNotSelected: {
    opacity: '.25'
  },
  table: {
    '& td': {
      padding: '5px'
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/Query/styles.js